import { Button, Modal, Typography, Checkbox } from "antd";

import React, { useState } from "react";
import { Form, Link } from "react-router-dom";
import { downloadEvent } from "utilities/generalUtility";

export default function TermsAndConditionModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
    downloadEvent("Terms&Condition");
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const { Title, Text } = Typography;

  return (
    <>
      <Link onClick={showModal}>Terms and Conditions</Link>
      <Modal
        className="cm-modal auth-modal"
        open={isModalOpen}
        centered
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        closeIcon={<i className="icon-close"></i>}
      >
        <Title level={3} className="text-center">
          <i className="icon-list"></i>Terms And Conditions
        </Title>
        <div className="modal-content">
          <div className="content-heading">
            <Title level={4}>
              Terms and Conditions for RESOLVEit.ai
              {/* <Text className="d-block">General Site Usage</Text> */}
            </Title>
            <Title level={4}>Last Updated: September 9, 2023</Title>
          </div>

          <p>
            1. Acceptance of Terms: By accessing and using RESOLVEit.ai ("the
            Service"), you agree to comply with these Terms and Conditions
            ("Terms"). If you do not agree with any of these Terms, refrain from
            using the Service.
          </p>
          <p>
            2. Usage Rights: We grant you a limited, non-exclusive,
            non-transferable right to access and use the Service for your
            internal business purposes, subject to these Terms.
          </p>
          <p>
            3. User Obligations: - You agree not to use the Service for any
            unlawful purposes or to conduct any unlawful activity. - You must
            not attempt to breach our security or authentication measures.
          </p>
          <p>
            4. User Content and Liability Release: - Purpose of the Service: The
            Service is designed primarily as a private journaling platform
            intended for communication between two users. - Acknowledgement of
            Potential Actions by Users: Users should be aware that content might
            be captured, replicated, or disseminated beyond the intended
            recipient or outside of the Service. - Release of Liability: You
            agree that RESOLVEit.ai Inc. shall not be held responsible or liable
            for any unauthorized dissemination or use of the content.
          </p>
          <p>
            5. Limitations of Conflict Resolution and Potential Disclosure: -
            Nature of Service: RESOLVEit.ai is designed to assist in conflict
            resolution between parties for general disputes. - Potential
            Disclosure in Legal Proceedings: Content or information provided to
            RESOLVEit.ai may be subject to discovery in legal proceedings. -
            Exclusions of Service: RESOLVEit.ai is not equipped for intense,
            legal, or deeply personal conflicts requiring professional
            intervention. - Recommendation for Professional Intervention: Users
            should consult with professionals for intense conflicts or legal
            implications. - Release of Liability: Users use RESOLVEit.ai at
            their own discretion and risk.
          </p>
          <p>
            6. AI Integration and Liability Release: - Nature of AI
            Interactions: Users acknowledge the AI portion of RESOLVEit.ai is a
            machine learning model with outputs based on its training data and
            the inputs it receives. - No Warranty on AI Outputs: RESOLVEit.ai
            provides no warranties about the accuracy or appropriateness of the
            AI's outputs. - Data Processing and Privacy: Anonymized inputs and
            interactions with the AI may be stored and analyzed, but no personal
            or identifiable information will be used for these purposes. -
            Release from Decisions Based on AI: Users assume responsibility for
            actions or decisions based on the AI. - Acknowledgement of AI
            Limitations: Users accept the inherent limitations of artificial
            intelligence. - No Emotional or Medical Reliance: The AI is not a
            substitute for professional judgment in emotional, medical, legal,
            or other specialized areas.
          </p>
          <p>
            7. Personality Type Testing and Liability Release: - Nature of
            Personality Testing: Users recognize that integrated tests such as
            MBTI and DISC are tools for personal insight and communication
            improvement. - No Decisive Actions Based on Results: Test results
            are interpretative and shouldn't be the primary basis for serious
            decisions. - Limitation on Interpretation: RESOLVEit.ai Inc. does
            not claim the accuracy or reliability of test results. - Release
            from Actions Taken Based on Results: Users release RESOLVEit.ai Inc.
            from any claims arising from actions based on their test results. -
            Recommendation for Professional Consultation: Users are advised to
            consult with qualified professionals for in-depth understanding
            based on test results.
          </p>
          <p>
            8. Use of Artificial Intelligence: - Acknowledgement of AI
            Technology: RESOLVEit.ai uses ChatGPT for its artificial
            intelligence functionalities. - Liability Limitations: RESOLVEit.ai
            is not responsible for any outcomes from the use of the AI portion
            of the platform.
          </p>
          <p>
            9. Limitation of Liability: - RESOLVEit.ai Inc., its affiliates, and
            service providers are not liable for any form of damages related to
            your use or inability to use the Service, data loss, or any content
            from the Service.
          </p>
          <p>
            10. Indemnification: You agree to indemnify and hold RESOLVEit.ai
            Inc. harmless from any claims, liabilities, damages, losses, and
            expenses related to your access to or use of the Service or your
            violation of these Terms.
          </p>
          <p>
            11. No Warranty: We provide the Service "as is" and "as available"
            without any warranties of any kind.
          </p>
          <p>
            12. Termination: - We may terminate or suspend your access to the
            Service at our discretion, at any time, and without notice to you. -
            Upon termination, your right to use the Service will cease.
          </p>
          <p>
            13. Modifications: We reserve the right to modify or replace these
            Terms at any time. It is your responsibility to review these Terms
            periodically.
          </p>
          <p>
            14. Intellectual Property: All content, trademarks, services marks,
            trade names, logos, and icons are proprietary to RESOLVEit.ai Inc.
          </p>
          <p>
            15. Data Protection: You acknowledge that you have read our Privacy
            Policy and understand how we collect, store, and use your personal
            data.
          </p>
          <p>
            16. Governing Law: These Terms are governed by the laws of Delaware.
          </p>
          <p>
            17. Dispute Resolution: Any dispute arising from these Terms shall
            be resolved through binding arbitration in Delaware.
          </p>
          <p>
            18. Miscellaneous: - These Terms constitute the entire agreement
            between you and RESOLVEit.ai Inc. concerning your use of the
            Service. - Our failure to enforce any right or provision of these
            Terms shall not constitute a waiver.
          </p>

          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus nec
            nulla sit sit commodo. Arcu tincidunt elit proin nisl dignissim.
            Ultrices vitae dignissim neque sed vel fringilla in arcu
            scelerisque. Tortor semper sit diam consectetur eros morbi dui. Sem
            lectus sit rutrum vulputate sed diam elementum neque suspendisse.
            Eu, phasellus sed sodales ut purus. Aliquam adipiscing purus,
            fermentum pellentesque nisl mauris. In morbi mattis felis ut in at.
            In dui aliquet in arcu ultrices quam porta ut neque
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus nec
            nulla sit sit commodo. Arcu tincidunt elit proin nisl dignissim.
            Ultrices vitae dignissim neque sed vel fringilla in arcu
            scelerisque. Tortor semper sit diam consectetur eros morbi dui. Sem
            lectus sit rutrum vulputate sed diam elementum neque suspendisse.
            Eu, phasellus sed sodales ut purus. Aliquam adipiscing purus,
            fermentum pellentesque nisl mauris. In morbi mattis felis ut in at.
            In dui aliquet in arcu ultrices quam porta ut neque. Parturient quam
            elit fermentum adipiscing vestibulum.{" "}
          </p> */}
        </div>

        <div className="auth-modal-btn-wrap mt-5">
          {/* <Button onClick={handleOk} type="primary" size="large">
            Accept
          </Button>
          <Button
            onClick={handleCancel}
            type="primary"
            ghost
            size="large"
            className="resend-btn"
          >
            Decline
          </Button> */}
        </div>
      </Modal>
    </>
  );
}
